import { render, staticRenderFns } from "./ConsultantRecords.vue?vue&type=template&id=68a0a9f2&scoped=true&"
import script from "./ConsultantRecords.vue?vue&type=script&lang=js&"
export * from "./ConsultantRecords.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantRecords.vue?vue&type=style&index=0&id=68a0a9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0a9f2",
  null
  
)

export default component.exports